var map = {
	"./images/avatar-old.jpg": 7363,
	"./images/avatar.jpeg": 713,
	"./images/bg-icon.jpg": 899,
	"./images/bg.jpg": 7338,
	"./images/icons/facebook.svg": 5437,
	"./images/icons/github.svg": 3342,
	"./images/icons/gmail.svg": 4803,
	"./images/icons/linkedin.svg": 2322,
	"./images/icons/twitter.svg": 6673,
	"./images/overlay.png": 714,
	"./images/page-not-found.png": 6159,
	"./images/screenshots/angular12-boilerplate-template.png": 3147,
	"./images/screenshots/angularjs-clipboard.png": 3442,
	"./images/screenshots/cms-blog.png": 5511,
	"./images/screenshots/customize-angular-slideable.png": 5476,
	"./images/screenshots/employee-payslip-generator.png": 2245,
	"./images/screenshots/excel-sheet-data.png": 1604,
	"./images/screenshots/jewellery-app.png": 2622,
	"./images/screenshots/optic-visions.png": 8022,
	"./images/screenshots/selectize-click-editable.png": 4144,
	"./images/screenshots/svelte-components-inside-angularjs.png": 2804,
	"./images/screenshots/svelte-table-component.png": 8423,
	"./images/screenshots/tooltip-css.png": 4530,
	"./images/screenshots/translator-application.png": 1920,
	"./images/website-icon.png": 6803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2474;